<template>
  <div>
    <div class="grid-x grid-padding-x">
      <div class="cell small-12">
        <div class="bordered pad">
          <h1>Tutor Groups</h1>
        </div>
      </div>
    </div>
    <div
      v-for="(group, index) in tutorGroups"
      v-bind:key="index"
      class="grid-x grid-padding-x pad-top">
      <div class="cell small-12">
        <div class="bordered pad">
          <h4>Tutor Group: {{ group.name }}</h4>
          <ul>
            <li
              v-for="(user, uindex) in group.users"
              v-bind:key="uindex">
              <router-link
                class="link"
                v-bind:to="`/view-user/${user.id}`">
                {{ user.first_name }} {{ user.last_name }}
                <span v-if="user._joinData.member_type === 2"> | Tutor</span>
              </router-link>
              &nbsp;
              <label v-if="messageGroup > -1">
                Select for email
                <input type="checkbox" v-model="user.sendMail"/>
              </label>
            </li>
          </ul>
          <button
            @click="messageGroup = index"
            class="button"
            v-if="messageGroup === -1">Message learners in group</button>
          <div v-if="messageGroup > -1">
            <p>Send an email to the selected learners in {{ group.name }}</p>
            <label>Message</label>
            <textarea rows="6" v-model="messageText"></textarea>
            <button @click="sendMessage" class="button">Send</button>
            &nbsp;
            <button @click="messageGroup = -1" class="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../axios';

export default {
  name: 'ViewTutorGroups',
  data() {
    return {
      messageGroup: -1,
      messageText: '',
      tutorGroups: [],
    };
  },
  computed: {
    authData() {
      return this.$store.getters.authData;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    getTutorGroups() {
      axios.get(`/tutorGroups/get.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`)
        .then((response) => {
          this.tutorGroups = response.data.tutorGroups;
          for (let i = 0; i < this.tutorGroups.length; i += 1) {
            for (let j = 0; j < this.tutorGroups[i].users.length; j += 1) {
              this.tutorGroups[i].users[j].sendMail = true;
            }
          }
        });
    },
    sendMessage() {
      const group = this.tutorGroups[this.messageGroup];
      const postData = {
        tutorGroupId: group.id,
        tutorGroup: group,
        message: this.messageText,
      };
      axios.post(`/tutorGroups/sendMessage.json?auth=${this.authData.token}&user=${this.authData.userId}&cage=${this.authData.cage}&level=${this.userLevel}`, postData)
        .then(() => {
          this.messageGroup = -1;
        });
    },
  },
  mounted() {
    this.getTutorGroups();
  },
};
</script>
